export default __webpack_public_path__ + "static/media/laptop-3.a30745d3.gif";